import useApi from '../api';

const useReportIndicatorValuesService = () => {
    const { api } = useApi();

    return {
        store: (data) => {
            return api.post('report-indicator-values', data).then((resp) => resp.data);
        },
        getByReportId: (reportId) => {
            return api
                .get('report-indicator-values', {
                    params: { report_id: reportId }
                })
                .then((resp) => resp.data);
        },
        getDashboardAverages: (params) => {
            return api.get('report-indicator-values/dashboard/averages', { params }).then((resp) => resp.data);
        },
        getDashboardResources: (enterpriseId) => {
            return api
                .get('report-indicator-values/dashboard/resources', { params: { enterprise_id: enterpriseId } })
                .then((resp) => resp.data);
        },
        getDashboardCharts: (params) => {
            return api.get('report-indicator-values/dashboard/charts', { params }).then((resp) => resp.data);
        }
    };
};

export default useReportIndicatorValuesService;
